import React from 'react';
import {
  Table,
  VertButton,
  Typography,
  VertContainer,
  VertTooltip,
} from '@vertem-core/vertice-ds';
import PropTypes from 'prop-types';
import { DeleteFilled, EditFilled } from '@ant-design/icons';
import ValuePriceForPoint from '../ValuePriceForPoint';
import { useMediaQuery } from 'react-responsive';
import useParticipantSubSegment from 'Hooks/useParticipantSubSegment';
import HierarchyProductEditionModal from 'pages/newSolicitation/modal/HierarchyProductEditionModal';
import { convertPoints } from 'Utils/maskFormat';

const TableProductHierarchy = ({ products, typeRedemption, validateAccess, undeliveredProducts }) => {
  const mediaQuery = useMediaQuery({ query: '(max-width: 768px)' });
  const { isLead } = useParticipantSubSegment();

  const [isOpenProductModalToEdit, setIsOpenProductModalToEdit] = React.useState(false);
  const [isOpenProductModalToRemove, setIsOpenProductModalToRemove] = React.useState(false);
  const [skuProductToEdit, setSkuProductToEdit] = React.useState(null);

  const columns = [
    {
      title: 'Produto',
      dataIndex: 'nomeProduto',
      key: 'nomeProduto',
      render: (_, { name, sku }) => (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Typography.Text>{name}</Typography.Text>
          {undeliveredProducts?.includes(sku)
            && <Typography.Text strong type='danger'>Produto não pode ser entregue</Typography.Text>}
        </div>
      ),
      width: '30%',
    },
    {
      title: typeRedemption === 3 ? 'Valor em Pontos ' : 'Valor em Reais',
      dataIndex: 'valor',
      key: 'valor',
      cellFontSize: '5px',
      width: '15%',
      render: (_, { unitPrice }) => (
        <div className="vert-product-table-spot-value">
          {/* <Typography.Text
            style={{
              // fontSize: mediaQuery ? "12px" : "14px",

              color: '#8C8C8C',
            }}
          >
            {new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(unitPrice)}
          </Typography.Text> */}
          {(validateAccess || isLead) && (
            <Typography.Text>{convertPoints((unitPrice), 0)} pontos</Typography.Text>
          )}
        </div>
      ),
    },
    {
      title: mediaQuery ? 'Qtd' : 'Quantidade',
      dataIndex: 'quantidade',
      key: 'quantidade',
      render: (_, { quantity }) => (
        <Typography.Text>{quantity}</Typography.Text>
      ),
      width: '15%',
    },
    {
      title: typeRedemption === 3 ? 'Total em Pontos' : 'Total em Reais',
      dataIndex: 'total',
      key: 'total',
      width: '30%',
      render: (_, { unitPrice, quantity }) => (
        <div className="vert-product-table-spot-value">
          {/* <Typography.Text
            style={{
              fontSize: mediaQuery ? '12px' : '14px',
              fontWeight: 'bold',
            }}
          >
            {new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(unitPrice * quantity)}
          </Typography.Text> */}
          {(validateAccess || isLead) && (
            <Typography.Text>{convertPoints((unitPrice * quantity), 0)} pontos</Typography.Text>
          )}
        </div>
      ),
    },
    {
      title: mediaQuery ? '' : 'Ações',
      dataIndex: 'acoes',
      key: 'acoes',
      width: '10%',
      render: (_, { sku }) => (
        <div className="vert-product-table-spot">
          <VertButton
            type="highlight"
            shape={'round'}
            icon={<EditFilled />}
            size={'small'}
            onClick={() => {
              setIsOpenProductModalToEdit(true);
              setSkuProductToEdit(sku);
            }}
          />
          <VertButton
            type="default"
            shape="round"
            icon={<DeleteFilled />}
            size={'small'}
            onClick={() => {
              setIsOpenProductModalToRemove(true);
              setSkuProductToEdit(sku);
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={products ?? []}
        pagination={false}
        bordered
        tableLayout="auto"
        sticky
        size={'small'}
        locale={{
          emptyText: 'Nenhum produto adicionado',
        }}
        scroll={{ x: 1000 }}
      />
      <HierarchyProductEditionModal
        isOpen={isOpenProductModalToEdit || isOpenProductModalToRemove}
        onClose={() => {
          setIsOpenProductModalToEdit(false)
          setIsOpenProductModalToRemove(false)
          setSkuProductToEdit(null)
        }}
        skuProductToEdit={skuProductToEdit}
        isEditModal={isOpenProductModalToEdit}
        isRemoveModal={isOpenProductModalToRemove}
      />
    </>
  );
};

export default TableProductHierarchy;

TableProductHierarchy.PropTypes = {
  products: PropTypes.array.isRequired,
  typeRedemption: PropTypes.string.isRequired,
  validateAccess: PropTypes.func.isRequired,
};
